import { useState, useEffect, Fragment } from 'react';
import toast from 'react-hot-toast';

import { permisosAPI } from '../services/api';

const ROL_LABELS = {
    superadmin: 'Super Admin',
    admin: 'Admin',
    gestor_proyecto: 'Gestor de Proyectos',
    comercial: 'Comercial',
    personal: 'Personal'
};

const RolesPanel = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [matriz, setMatriz] = useState({});
    // grupos: [{ grupo: 'Cotizaciones', items: [{key, label}] }, ...]
    const [grupos, setGrupos] = useState([]);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        cargarPermisos();
    }, []);

    const cargarPermisos = async () => {
        setLoading(true);
        try {
            const res = await permisosAPI.getAll();
            const { matriz: m, permisosDisponibles: pd, roles: r } = res.data;
            setMatriz(m);
            // Compatibilidad: si el backend manda formato viejo (array plano),
            // lo metemos en un solo grupo "Permisos" para no romper el render.
            const esAgrupado = Array.isArray(pd) && pd.length > 0 && pd[0].items;
            setGrupos(esAgrupado ? pd : [{ grupo: 'Permisos', items: pd || [] }]);
            setRoles(r);
        } catch (err) {
            toast.error('Error al cargar permisos: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    const togglePermiso = (rol, permiso) => {
        if (rol === 'superadmin') return; // no editable
        setMatriz(prev => ({
            ...prev,
            [rol]: {
                ...prev[rol],
                [permiso]: !prev[rol]?.[permiso]
            }
        }));
    };

    const guardarTodo = async () => {
        setSaving(true);
        try {
            const editableRoles = roles.filter(r => r !== 'superadmin');
            for (const rol of editableRoles) {
                await permisosAPI.update(rol, matriz[rol] || {});
            }
            toast.success('Permisos actualizados correctamente');
        } catch (err) {
            toast.error('Error: ' + err.message);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="loading">Cargando permisos...</div>;
    }

    return (
        <div className="card">
            <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                <h2>Roles y Permisos</h2>
            </div>
            <div className="admin-content">
                <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '16px', fontSize: '0.9rem' }}>
                    Define qué acciones puede realizar cada rol. SuperAdmin siempre tiene todos los permisos.
                </p>

                <div className="tableWrap">
                    <table className="galTable permisos-tabla">
                        <thead>
                            <tr>
                                <th style={{ minWidth: '260px' }}>Permiso</th>
                                {roles.map(rol => (
                                    <th key={rol} style={{ textAlign: 'center', minWidth: '120px' }}>
                                        {ROL_LABELS[rol] || rol}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {grupos.map((g, gi) => (
                                <Fragment key={`grupo-${gi}`}>
                                    <tr className="permisos-grupo-row">
                                        <th
                                            colSpan={1 + roles.length}
                                            scope="colgroup"
                                            className="permisos-grupo-header"
                                        >
                                            {g.grupo}
                                        </th>
                                    </tr>
                                    {(g.items || []).map(p => (
                                        <tr key={p.key}>
                                            <td className="permisos-label-cell">{p.label}</td>
                                            {roles.map(rol => (
                                                <td key={rol} style={{ textAlign: 'center' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={rol === 'superadmin' ? true : !!matriz[rol]?.[p.key]}
                                                        disabled={rol === 'superadmin'}
                                                        onChange={() => togglePermiso(rol, p.key)}
                                                        className="permisos-checkbox"
                                                    />
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="divider" />

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                        className="btn neon"
                        onClick={guardarTodo}
                        disabled={saving}
                    >
                        {saving ? 'Guardando...' : 'Guardar Permisos'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RolesPanel;
